import { createStoreProvider, ReduxStore } from '@st/redux'
import { authModule } from './features/auth/auth-module'

import * as Sentry from '@sentry/browser'
import { JsonMap } from '@st/util/json-value'
import { truncate } from '@st/util/truncate'
import { routeModule } from './features/route-module'

function makeSTReduxStore() {
  return new ReduxStore({
    name: 'st',
    modules: [routeModule, authModule],
    onEvent: (event, context) => {
      Sentry.addBreadcrumb({
        type: 'info',
        level: 'info',
        category: 'redux',
        message: event.type,
        data: truncate(event as JsonMap, {
          maxArrayLength: 10,
          maxKeys: 10,
          maxStringLength: 100
        }) as any
      })
    },
    onError: (error) => {
      Sentry.captureException(error)
    }
  })
}

export let ST_REDUX_STORE: ReduxStore

if (import.meta.hot) {
  ST_REDUX_STORE = import.meta.hot.data.store ?? (import.meta.hot.data.store = makeSTReduxStore())
  import.meta.hot.accept() // keep using the same instance next swap
} else {
  ST_REDUX_STORE = makeSTReduxStore()
}

export const { StoreProvider, useStore, useProcessState, useProcess, useProcessMessages } =
  createStoreProvider()
